import { Button } from 'antd';
import Icon from '@ant-design/icons';

import useTemplateState from '../../../../atoms/variables';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NeedHelpButton = () => {
  const { t } = useTranslation();
  const { companyInfo } = useTemplateState();
  const navigate = useNavigate();
  const iconSvg = () => (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.44686 3.42857C7.2953 3.42857 7.14996 3.48878 7.0428 3.59594C6.93563 3.7031 6.87543 3.84845 6.87543 4C6.87543 4.15155 6.93563 4.2969 7.0428 4.40406C7.14996 4.51123 7.2953 4.57143 7.44686 4.57143H10.6206L5.88114 9.30971C5.82801 9.36284 5.78587 9.42592 5.75712 9.49533C5.72836 9.56475 5.71356 9.63915 5.71356 9.71429C5.71356 9.78942 5.72836 9.86382 5.75712 9.93324C5.78587 10.0027 5.82801 10.0657 5.88114 10.1189C5.93427 10.172 5.99735 10.2141 6.06676 10.2429C6.13618 10.2716 6.21058 10.2864 6.28571 10.2864C6.36085 10.2864 6.43525 10.2716 6.50467 10.2429C6.57408 10.2141 6.63716 10.172 6.69029 10.1189L11.4286 5.37943V8.55314C11.4286 8.7047 11.4888 8.85004 11.5959 8.9572C11.7031 9.06437 11.8484 9.12457 12 9.12457C12.1516 9.12457 12.2969 9.06437 12.4041 8.9572C12.5112 8.85004 12.5714 8.7047 12.5714 8.55314V4C12.5714 3.84845 12.5112 3.7031 12.4041 3.59594C12.2969 3.48878 12.1516 3.42857 12 3.42857H7.44686ZM11.1611 16C11.8418 16.0002 12.5001 15.7573 13.0176 15.3153C13.5351 14.8732 13.8778 14.2609 13.984 13.5886C14.5679 13.4087 15.0788 13.0463 15.4417 12.5547C15.8045 12.0631 16.0002 11.4682 16 10.8571V2.85714C16 2.09938 15.699 1.37266 15.1632 0.836838C14.6273 0.30102 13.9006 1.75912e-07 13.1429 1.75912e-07H5.14286C4.5251 -0.000216532 3.9239 0.199796 3.4294 0.570057C2.93489 0.940318 2.57371 1.46088 2.4 2.05371C1.72999 2.16232 1.12052 2.5059 0.680761 3.02293C0.241 3.53997 -0.000327484 4.19667 3.33539e-07 4.87543V12C3.33539e-07 13.0609 0.421428 14.0783 1.17157 14.8284C1.92172 15.5786 2.93913 16 4 16H11.1611ZM1.14286 4.87543C1.14243 4.52057 1.25214 4.17434 1.45684 3.88448C1.66155 3.59462 1.95116 3.37543 2.28571 3.25714V10.8571C2.28571 11.6149 2.58673 12.3416 3.12255 12.8774C3.65837 13.4133 4.3851 13.7143 5.14286 13.7143H12.7771C12.659 14.0485 12.4401 14.3378 12.1507 14.5425C11.8613 14.7472 11.5156 14.8571 11.1611 14.8571H4C3.24224 14.8571 2.51551 14.5561 1.9797 14.0203C1.44388 13.4845 1.14286 12.7578 1.14286 12V4.87543ZM5.14286 1.14286H13.1429C13.5975 1.14286 14.0335 1.32347 14.355 1.64496C14.6765 1.96645 14.8571 2.40249 14.8571 2.85714V10.8571C14.8571 11.3118 14.6765 11.7478 14.355 12.0693C14.0335 12.3908 13.5975 12.5714 13.1429 12.5714H5.14286C4.6882 12.5714 4.25217 12.3908 3.93067 12.0693C3.60918 11.7478 3.42857 11.3118 3.42857 10.8571V2.85714C3.42857 2.40249 3.60918 1.96645 3.93067 1.64496C4.25217 1.32347 4.6882 1.14286 5.14286 1.14286Z'
        fill='#1777FF'
      />
    </svg>
  );

  const buttonIcon = <Icon component={iconSvg} />;

  return (
    <Button
      icon={buttonIcon}
      size='large'
      style={{
        color: '#1777FF',
        borderColor: '#1777FF',
      }}
      onClick={() => {
        eval(companyInfo?.needHelp)();
      }}
    >
      {t('open_ticket')}
    </Button>
  );
};

export default NeedHelpButton;
